import JSEncrypt from "jsencrypt";

export default class EncryptionService {
	private static encryptor = (() => {
		const base64Key = process.env.REACT_APP_ENCRYPTION_PUBLIC_KEY!;
		const pem = `-----BEGIN PUBLIC KEY-----
${base64Key}
-----END PUBLIC KEY-----`;

		const encryptor = new JSEncrypt();

		encryptor.setPublicKey(pem);

		return encryptor;
	})();

	public static encryptPassword(value: string): string {
		const encrypted = this.encryptor.encrypt(value);

		if (!encrypted) throw new Error("Unable to encrypt");

		return encrypted;
	}
}
